// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primary":"#492172","accent":"#BFD730"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/styles/modules/index.scss
// module id = GVji
// module chunks = 0